import axiosInstance from "../../api/axiosInstance";

export const fetchAdminsByTournamentIdAPI = async (tournamentId) => {
  const admins = await axiosInstance.get(
    `controlledTournaments/get-admins-for-one-tournament/${tournamentId}`
  );

  return admins.data;
};

export const addControlledTournamentsAPI = async (adminId, tournamentIds) => {
  const controlledTournaments = axiosInstance.post(
    "controlledTournaments/add-tournaments",
    {
      adminId,
      newTournaments: tournamentIds,
    }
  );

  return controlledTournaments;
};

export const removeControlledTournamentsAPI = async (
  adminId,
  tournamentIds
) => {
  const controlledTournaments = axiosInstance.post(
    "controlledTournaments/remove-tournaments",
    {
      adminId,
      tournamentIds,
    }
  );

  return controlledTournaments;
};
